export const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result as string);
      } else {
        reject(new Error('Failed to read blob as base64'));
      }
    };
    reader.onerror = () => {
      reject(new Error('An error occurred while reading the blob'));
    };

    reader.readAsDataURL(blob);
  });
};

export const dataURLtoFile = (dataURL: string, fileName: string): File => {
  try {
    const arr = dataURL.split(',');
    const mime = arr[0]?.match(/:(.*?);/)?.[1];

    if (!mime || !arr[1]) {
      throw new Error('Invalid data URL format');
    }

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  } catch {
    throw new Error('Invalid data URL format');
  }
};
